module.exports = __webpack_public_path__ + "img/hr-level3addon_mining_hands_mask.3d457bd6.png";